module.exports = __webpack_public_path__ + "static/media/16UNODC5.a66cf361.jpg";